import {
    Add,
    Archive,
    DeliveryDining,
    FoodBank,
    ShoppingCartCheckout,
} from "@mui/icons-material";
import {
    Badge,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AppContext";
import { isRoleService } from "../frappeConfig";
import ExpenseClaimDialog from "../pages/PosPage/components/ExpenseClaimDialog/ExpenseClaimDialog";

const SimpleSpeedDialActions = ({
    handleTakeawayOrders,
    handleClosedOrders,
    notifications,
}) => {
    const navigate = useNavigate();
    const { userInfo, isTabsPos } = useContext(AppContext);

    const [closePOSDialogOpen, setClosePOSDialogOpen] = useState(false);

    const handleExpenseClaimClose = () => {
        setClosePOSDialogOpen(false);
    };

    const onConfirmExpenseClaim = () => {
        setClosePOSDialogOpen(false);
    };

    const speedDialActions = () => {
        if (isTabsPos) {
            return [
                {
                    label: "New Order",
                    icon: <Add />,
                    onClick: () => {
                        navigate("/pos/takeaway");
                    },
                },
                {
                    label: "Expense claim",
                    icon: <ShoppingCartCheckout />,
                    onClick: () => {
                        setClosePOSDialogOpen(true);
                    },
                },
                {
                    label: "Closed Orders",
                    icon: <Archive />,
                    onClick: () => {
                        handleClosedOrders?.();
                    },
                },
            ];
        } else if (isRoleService(userInfo.role_profile_name)) {
            return [
                {
                    label: "Takeaway Orders",
                    icon: <FoodBank />,
                    onClick: () => {
                        handleTakeawayOrders?.();
                    },
                },
            ];
        } else {
            return [
                {
                    label: "Takeaway",
                    icon: <DeliveryDining />,
                    onClick: () => {
                        navigate("/pos/takeaway");
                    },
                },
                {
                    label: "Takeaway Orders",
                    icon: <FoodBank />,
                    onClick: () => {
                        handleTakeawayOrders?.();
                    },
                },
                {
                    label: "Expense claim",
                    icon: <ShoppingCartCheckout />,
                    onClick: () => {
                        setClosePOSDialogOpen(true);
                    },
                },
                {
                    label: "Closed Orders",
                    icon: <Archive />,
                    onClick: () => {
                        handleClosedOrders?.();
                    },
                },
            ];
        }
    };

    return (
        <React.Fragment>
            <SpeedDial
                icon={
                    <Badge
                        color="secondary"
                        badgeContent={notifications?.openingEntries}
                    >
                        <SpeedDialIcon />
                    </Badge>
                }
                ariaLabel="Speed Dial"
                sx={{
                    position: "absolute",
                    bottom: 15,
                    right: 15,
                }}
            >
                {speedDialActions().map((action) => (
                    <SpeedDialAction
                        key={"Speed_Dial_" + action.label}
                        icon={action.icon}
                        aria-label={action.label}
                        tooltipTitle={action.label}
                        tooltipOpen
                        onClick={action.onClick}
                    />
                ))}
            </SpeedDial>

            <ExpenseClaimDialog
                dialogOpen={closePOSDialogOpen}
                onCancel={handleExpenseClaimClose}
                onConfirm={onConfirmExpenseClaim}
                // selectedCustomer={selectedCustomer}
                // customerSelected={onCustomerSelected}
            ></ExpenseClaimDialog>
        </React.Fragment>
    );
};

export default SimpleSpeedDialActions;
